module.exports = __webpack_public_path__ + "static/media/56.64fa6b00.jpg";